/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {Asset, Entity} from '@ion/core/src/types/entities';
import {capitalizeFirstLetter} from '@ion/core/src/utils/StringUtil';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import {errorOptions, successOptions} from '../../../components/prompts/constants';

/**
 * constructAssetGridRows
 *
 * Takes a list of assets and constructs a list that
 * can be easily consumed by the IonGrid API
 */
export const constructAssetGridRows = (assets: Asset[]): GridResult[] => {
  return assets.map(asset => ({
    group        : asset?.account?.title,
    name         : asset?.name,
    type         : asset?.assetType,
    category     : asset?.assetCategory,
    schedule     : asset?.schedules,
    device       : asset?.devices[0]?.title,
    associations : getAssociations(asset),
    status       : asset?.status,
    assetId      : asset?.id
  }));
};

/**
 * getAssociations
 *
 * utility that gets associated assets to an asset and
 * returns a comma concatenated string of all associations
 */
export const getAssociations = (asset: Asset) => {
  if (asset) {
    const {assets} = asset;
    const n = assets ? assets.length : 0;
    if (n) {
      let associations = '';
      assets.forEach((asset, i) => {
        associations += asset.title + (i < n-1 ? ', ' : '');
      });
      return associations;
    }
  }
  return '';
};

/**
 * successAddOptions
 *
 * Results for the successful add asset user prompt that
 * extend the default options
 */
export const successAddOptions = {
  ...successOptions,
  message         : 'common:editors.shared.successCreated',
  translateOption : {
    entity : capitalizeFirstLetter(Entity.asset)
  }
};

/**
 * errorOptions
 *
 * Results for the error add asset user prompt that
 * extend the default options
 */
export const errorAddOptions = {
  ...errorOptions,
  message         : 'common:editors.shared.errorCreated',
  translateOption : {
    entity : Entity.asset
  }
};

/**
 * successEditOptions
 *
 * Results for the successful edit asset user prompt that
 * extend the default options
 */
export const successEditOptions = {
  ...successAddOptions,
  message : 'common:editors.shared.successEdited'
};

/**
 * errorOptions
 *
 * Results for the error add asset user prompt that
 * extend the default options
 */
export const errorEditOptions = {
  ...errorAddOptions,
  message : 'common:editors.shared.errorEdited'
};
